import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import DataDiscrepancy2_6 from '@/views/2.6/DataDiscrepancy.vue';
import DataDiscrepancy3_6 from '@/views/3.6/DataDiscrepancy.vue';

const routes: Array<RouteRecordRaw> = [
    { path: '/', name: 'DataDiscrepancy', component: DataDiscrepancy2_6 },
    { path: '/2.6', name: 'DataDiscrepancy2_6', component: DataDiscrepancy2_6 },
    { path: '/3.6', name: 'DataDiscrepancy3_6', component: DataDiscrepancy3_6 },
    { path: '/error', name: 'Error', component: () => import('@/views/Error.vue') },
    { path: '/:catchAll(.*)*', name: '404', component: () => import('@/views/404.vue') }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
